import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ShieldCheckIcon, PackageIcon, ClockIcon } from 'lucide-react';
export const CallToAction = () => {
  return <section className="py-16 md:py-20 border-t border-slate-200" data-id="element-300">
      <h2 className="text-2xl font-bold text-center text-slate-800 mb-4 px-4" data-id="element-301">
        Optimize Your Executive Performance
      </h2>
      <p className="text-center text-slate-600 mb-10 px-4" data-id="element-302">
        Join leading professionals who have discovered the NightPhase advantage
      </p>
      <div className="flex flex-col md:flex-row gap-8 mb-16" data-id="element-303">
        <div className="md:w-1/3" data-id="element-304">
          <img src="https://images.unsplash.com/photo-1556741533-6e6a62bd8b49?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=80" alt="Sleep patch product" className="w-full h-64 md:h-full object-cover rounded-xl shadow-md" data-id="element-305" />
        </div>
        <div className="md:w-2/3 bg-gradient-to-r from-indigo-600 to-indigo-800 rounded-xl overflow-hidden shadow-lg" data-id="element-306">
          <div className="p-6 md:p-8" data-id="element-307">
            <h3 className="text-xl font-bold text-white mb-6" data-id="element-308">
              NightPhase Sleep Patch Executive Performance Package
            </h3>
            <ul className="space-y-5 mb-8" data-id="element-309">
              <li className="flex items-start" data-id="element-310">
                <PackageIcon className="h-5 w-5 text-indigo-200 mr-3 mt-0.5 flex-shrink-0" data-id="element-311" />
                <div data-id="element-312">
                  <p className="text-white font-medium" data-id="element-313">
                    30-Night Supply of NightPhase Patches
                  </p>
                  <p className="text-indigo-200 text-sm" data-id="element-314">
                    Experience our proprietary 4-Plant Botanical Blend™ with
                    NightPhase Delivery™ technology
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-315">
                <ClockIcon className="h-5 w-5 text-indigo-200 mr-3 mt-0.5 flex-shrink-0" data-id="element-316" />
                <div data-id="element-317">
                  <p className="text-white font-medium" data-id="element-318">
                    Executive Sleep Protocol Guide
                  </p>
                  <p className="text-indigo-200 text-sm" data-id="element-319">
                    Custom sleep optimization strategies for high-performance
                    professionals
                  </p>
                </div>
              </li>
              <li className="flex items-start" data-id="element-320">
                <ShieldCheckIcon className="h-5 w-5 text-indigo-200 mr-3 mt-0.5 flex-shrink-0" data-id="element-321" />
                <div data-id="element-322">
                  <p className="text-white font-medium" data-id="element-323">
                    Performance Tracking System
                  </p>
                  <p className="text-indigo-200 text-sm" data-id="element-324">
                    Proprietary tools to measure your cognitive and professional
                    ROI
                  </p>
                </div>
              </li>
            </ul>
            <div className="bg-white bg-opacity-10 p-5 rounded-lg mb-8" data-id="element-325">
              <div className="flex justify-between items-center mb-3" data-id="element-326">
                <p className="text-white font-medium" data-id="element-327">Regular Price:</p>
                <p className="text-white line-through" data-id="element-328">$297</p>
              </div>
              <div className="flex justify-between items-center" data-id="element-329">
                <p className="text-white font-bold" data-id="element-330">Limited Time Offer:</p>
                <p className="text-white font-bold text-xl" data-id="element-331">$197</p>
              </div>
            </div>
            <div className="flex items-center justify-center mb-6" data-id="element-332">
              <ShieldCheckIcon className="h-5 w-5 text-indigo-200 mr-2" data-id="element-333" />
              <p className="text-indigo-100 text-sm" data-id="element-334">
                30-Night Performance Guarantee
              </p>
            </div>
            <Link to="/pdp" className="w-full bg-white text-indigo-800 font-bold py-4 px-6 rounded-lg hover:bg-indigo-50 transition duration-200 flex items-center justify-center" data-id="element-335">
              Secure Your Performance Package
              <ArrowRightIcon className="h-5 w-5 ml-2" data-id="element-336" />
            </Link>
            <p className="text-center text-indigo-200 text-sm mt-4" data-id="element-337">
              Limited inventory available due to high demand
            </p>
          </div>
        </div>
      </div>
      <div className="text-center px-4" data-id="element-338">
        <h3 className="text-xl font-semibold text-slate-800 mb-6" data-id="element-339">
          Invest in Your Most Valuable Asset: Your Performance
        </h3>
        <p className="text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-340">
          NightPhase is more than a sleep aid—it's a professional performance
          tool trusted by executives, entrepreneurs, and high achievers who
          understand that optimal sleep is the foundation of exceptional
          performance.
        </p>
        <Link to="/pdp" className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-4 px-10 rounded-lg transition duration-200 text-lg" data-id="element-341">
          Get Started Now
        </Link>
      </div>
    </section>;
};